import '../../Player.css';

import React,{useState, useContext, useEffect, useCallback} from 'react';
import { PlayerContext } from '../../PlayerContext';
import { useTranslation } from 'react-i18next';
import { analyticsManager } from '../../../index';
import BookDialog, {phoneType, internetBookingType, chatType, internetOrderingType, internetSecondaryType} from './BookDialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Alert } from '@mui/material';
import {browserLocales, computeBookingSizeMultiplier, getDemoBookingMockPath, getDomainName, getStoryDisplayName, isDemoBookingMockUrl, isIOS, isSnapchatInAppBrowser, usesDemoBookingMock} from '../../Utils';
import {bookType, applyType, contactType, orderType} from '../components/PrimaryButton';
import { storyHasOrderingPlatforms } from '../../chainRestaurantUtils';
import WebPageMock from '../components/WebPageMock';
import DialogContainer from '../components/DialogContainer';
import IconButton from '@mui/material/IconButton';
import PhoneIcon from '@mui/icons-material/Phone';
import DeviceDetector from "device-detector-js";
import { getStoredPixelConsent } from '../../PixelConsentOverlay';

function BookScreen(props){

    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedPhone, setSelectedPhone] = useState(null);
    const [isOpened, setIsOpened] = useState(false);
    const [demoToastKey, setDemoToastKey] = useState(null);

    const activeFeature = useContext(PlayerContext).get("activeFeature");
    const setActiveFeature = useContext(PlayerContext).get("setActiveFeature");
    const propagateFocusChange = useContext(PlayerContext).get("propagateFocusChange");
    const playMode = useContext(PlayerContext).get("playMode");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier");
    const [frameOpened, setFrameOpened] = useState(false);
    const [frameWithImageOverWebsite, setFrameWithImageOverWebsite] = useState(true);    
    const [frameWidth, setFrameWidth] = useState(null);
    const [frameHeight, setFrameHeight] = useState(null);
    const storyDimensions = useContext(PlayerContext).get("storyDimensions");

    const openIframeFrame = useCallback((url) => {
        setDemoToastKey(null);
        setFrameOpened(url);
        setFrameWithImageOverWebsite(false);
        setFrameWidth(null);
        setFrameHeight(null);
    }, []);


    let btnType = null; 
    if (!props.story){
        btnType = null;
    }
    else if (props.storyId === "cJU0Fnom8MTjmokacI3I" || props.storyId === "WX2KsZRK4SNKT9hnNIp0"){
        btnType = applyType;
    }
    else if ((props.story.posBookingLink == null || props.story.posBookingLink === "none") && !storyHasOrderingPlatforms(props.story) /*&& !props.story.posBookingByPhone*/ || props.story.posId === "ChIJC4g4KBNx5kcRH_z3vKUpnZw"){
        btnType = contactType;
    }
    else if ((props.story.posBookingLink == null || props.story.posBookingLink === "none") && storyHasOrderingPlatforms(props.story)){
        btnType = orderType;
    }
    else {
        btnType = bookType;
    }

    const { t, i18n } = useTranslation();        

    const closeBookingMenu = () => {
        setIsOpened(false);
        setActiveFeature(null);
        setDemoToastKey(null);
        analyticsManager.logOpenPopupTag(props.storyId, "book", false, playMode);
    };

    const deliveryToast = demoToastKey ? (
        <div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: storyDimensions.containerWidth,
                height: storyDimensions.containerHeight,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 50,
                pointerEvents: "none",
            }}
        >
            <Alert
                severity="info"
                variant="filled"
                icon={false}
                sx={{
                    width: "fit-content",
                    maxWidth: "calc(100% - " + (32 * (sizeMultiplier || 1)) + "px)",
                    fontSize: Math.max(11, Math.round(13 * (sizeMultiplier || 1))),
                    py: 0.5,
                    px: 1.5,
                    justifyContent: "center",
                    textAlign: "center",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
                    "& .MuiAlert-message": {
                        padding: 0,
                        textAlign: "center",
                        width: "100%",
                    },
                }}
            >
                {t(demoToastKey)}
            </Alert>
        </div>
    ) : null;
    
    useEffect(() => {
        if (!demoToastKey) {
            return undefined;
        }
        const hideId = window.setTimeout(() => setDemoToastKey(null), 3500);
        return () => window.clearTimeout(hideId);
    }, [demoToastKey]);

    useEffect(() => {
        if (props.story.posBookingLink && !frameWithImageOverWebsite && frameOpened){
            setFrameOpened(props.story.posBookingLink);
        }
    }
    , [props.story]);    
        
    if (props.show && props.story.posId != null && (props.story.posPhone && props.story.posPhone.trim() !== "" && props.story.posBookingByPhone != false  || props.story.posBookingLink != null || props.story.orderingPlatforms != null || props.story.posChatLink != null)){        
        if (activeFeature === "book"){           
            const optionsToShow = {};
            
            if (props.story.email != null){
                optionsToShow.email = props.story.email;
            }

            if (props.storyId === "cJU0Fnom8MTjmokacI3I"){
                optionsToShow.phone = "01 76 35 12 43";
            }            
            else if (props.story.posPhone && props.story.posPhone.trim() !== "" && props.story.posPhone !== "none"){
                optionsToShow.phone = props.story.posPhone;                
            }
            if (props.story.posBookingLink != null){
                if (props.story.posBookingLink === "googlemaps"){                                                            
                    const address = props.story.mapsSearchQuery || "";
                    const query = props.story.posName + (address ? ", " + address : "");            
                    optionsToShow.webLink = "https://www.google.com/maps/search/?api=1&query=" + encodeURI(query);                                  
                }
                else
                    optionsToShow.webLink = props.story.posBookingLink;
            }
            if (props.story.posChatLink != null){
                optionsToShow.chatLink = props.story.posChatLink;
            }
        
            const close = (bookingType, value = null, label = null) => {                  
                if (bookingType !== phoneType){     
                    setSelectedValue(null);               
                    if (bookingType === internetBookingType){                        
                        if (playMode !== "demo" && props.storyId != null && !usesDemoBookingMock(props.storyId, props.story)){                             
                            if (optionsToShow.webLink.startsWith("https://bookings.zenchef.com")){                                
                                const langParam = browserLocales(true)[0] !== "fr" ? "&lang=en" : "";
                                openIframeFrame(optionsToShow.webLink + langParam);
                            }
                            else if (optionsToShow.webLink.startsWith("https://widget.thefork.com")){
                                const langParam = browserLocales(true)[0];
                                const bookingLink = optionsToShow.webLink.replace(
                                    /https:\/\/widget\.thefork\.com\/[a-z]{2}\//,
                                    `https://widget.thefork.com/${langParam === "fr" ? "fr" : "en"}/`
                                );
                                openIframeFrame(bookingLink);
                            }
                            else if (isDemoBookingMockUrl(optionsToShow.webLink)) {
                                const bookingIframeWidth = storyDimensions.containerWidth - 32;
                                openIframeFrame(getDemoBookingMockPath(props.storyId, props.story, {
                                    displayName: getStoryDisplayName(props.story, props.storyId),
                                    sizeMultiplier: computeBookingSizeMultiplier(bookingIframeWidth),
                                    lng: i18n.language,
                                }));
                            }
                            else {
                                closeBookingMenu();
                                propagateFocusChange(false);
                                window.open(optionsToShow.webLink);                                
                            }
                            analyticsManager.logBookTag(props.storyId, playMode, "website");  
                            if (getStoredPixelConsent() === 'accepted') {
                                if (btnType === bookType){
                                    if (window.ttq){                                
                                        window.ttq.track('InitiateBooking', {                
                                            "contents": [
                                                {              
                                                    "content_id": "0",           
                                                    "content_name": "initiate a booking on an external website",
                                                }
                                            ],
                                        });                                
                                    }  
                                    if (window.fbq){                    
                                        window.fbq('trackCustom', 'InitiateBooking', {"content_name": "initiate a booking on an external website"});
                                    }
                                }
                                else if (btnType === applyType){
                                    if (window.ttq){                                
                                        window.ttq.track('InitiateApply', {                
                                            "contents": [
                                                {              
                                                    "content_id": "0",           
                                                    "content_name": "initiate an applying on an external website",
                                                }
                                            ],
                                        });                                
                                    }  
                                    if (window.fbq){                    
                                        window.fbq('trackCustom', 'InitiateApply', {"content_name": "initiate an applying on an external website"});
                                    }
                                }
                            }
                        }                    
                        else{
                            const bookingIframeWidth = storyDimensions.containerWidth - 32;
                            openIframeFrame(getDemoBookingMockPath(props.storyId, props.story, {
                                displayName: getStoryDisplayName(props.story, props.storyId),
                                sizeMultiplier: computeBookingSizeMultiplier(bookingIframeWidth),
                                lng: i18n.language,
                            }));
                        }
                    }  
                    else if (bookingType === internetSecondaryType){  
                        closeBookingMenu();
                        propagateFocusChange(false);
                        window.open("https://www.holbertonschool.fr/contact");                                
                        analyticsManager.logBookTag(props.storyId, playMode, "website");
                        if (getStoredPixelConsent() === 'accepted') {
                            if (window.ttq){
                                window.ttq.track('InitiateContact', {                
                                    "contents": [
                                        {              
                                            "content_id": "0",           
                                            "content_name": "initiate contact on website",
                                        }
                                    ],
                                });
                            }
                            if (window.fbq){                    
                                window.fbq('trackCustom', 'InitiateContact', {"content_name": "initiate contact on website"});
                            }
                        }
                    }
                    else if (bookingType === internetOrderingType){                                                     
                        if (playMode !== "demo" && props.storyId != null && !usesDemoBookingMock(props.storyId, props.story)){                            
                            closeBookingMenu();
                            propagateFocusChange(false);
                            window.open(value);                                
                        
                            analyticsManager.logBookTag(props.storyId, playMode, "ordering_platform");
                            if (getStoredPixelConsent() === 'accepted') {
                                if (window.ttq){
                                    window.ttq.track('InitiateOrder', {                
                                        "contents": [
                                            {              
                                                "content_id": "0",           
                                                "content_name": "initiate order on " + getDomainName(value),
                                            }
                                        ],
                                    });
                                }
                                if (window.fbq){                    
                                    window.fbq('trackCustom', 'InitiateOrder', {"content_name": "initiate order on " + getDomainName(value)});
                                }
                            }
                        }    
                        else {
                            setDemoToastKey("DemoDeliveryPlatformToast");
                        }
                    }      
                    else if (bookingType === chatType){
                        if (playMode !== "demo" && props.storyId != null && !usesDemoBookingMock(props.storyId, props.story)){                            
                            closeBookingMenu();
                            propagateFocusChange(false);
                            window.open(optionsToShow.chatLink);
                            analyticsManager.logBookTag(props.storyId, playMode, "chat");
                            if (getStoredPixelConsent() === 'accepted') {
                                if (window.ttq){                                
                                    if (btnType === bookType){
                                        window.ttq.track('InitiateBooking', {                
                                            "contents": [
                                                {              
                                                    "content_id": "0",           
                                                    "content_name": "initiate a chat",
                                                }
                                            ],
                                        });
                                    }
                                    else if (btnType === contactType || btnType === applyType){
                                        window.ttq.track('InitiateContact', {                
                                            "contents": [
                                                {              
                                                    "content_id": "0",           
                                                    "content_name": "initiate a chat",
                                                }
                                            ],
                                        });
                                    }
                                    else if (btnType === orderType){
                                        window.ttq.track('InitiateOrdering', {                
                                            "contents": [
                                                {              
                                                    "content_id": "0",           
                                                    "content_name": "initiate a chat",
                                                }
                                            ],
                                        });
                                    }
                                }
                                if (window.fbq){                                   
                                    if (btnType === bookType){
                                        window.fbq('trackCustom', 'InitiateBooking', {"content_name": "initiate a chat"});
                                    }
                                    else if (btnType === contactType || btnType === applyType){
                                        window.fbq('trackCustom', 'InitiateContact', {"content_name": "initiate a chat"});
                                    } 
                                    else if (btnType === orderType){
                                        window.fbq('trackCustom', 'InitiateOrdering', {"content_name": "initiate a chat"});
                                    }                                
                                }
                            }
                        }
                        else {
                            setDemoToastKey("DemoInstagramChatToast");
                        }
                    }
                    else {
                        closeBookingMenu();
                    }
                }
                else {                   
                    const deviceDetector = new DeviceDetector();
                    const device = deviceDetector.parse(window.navigator.userAgent);                                
                    analyticsManager.logBookTag(props.storyId, playMode, "phone");
                    if (getStoredPixelConsent() === 'accepted') {
                        if (window.ttq){                        
                            if (btnType === bookType){
                                window.ttq.track('InitiateBooking', {                
                                    "contents": [
                                        {              
                                            "content_id": "0",           
                                            "content_name": "initiate a phone call" + (label ? " for " + label : ""),
                                        }
                                    ],
                                });
                            }
                            else if (btnType === contactType || btnType === applyType){
                                window.ttq.track('InitiateContact', {                
                                    "contents": [
                                        {              
                                            "content_id": "0",           
                                            "content_name": "initiate a phone call" + (label ? " for " + label : ""),
                                        }
                                    ],
                                });
                            }
                            else if (btnType === orderType){
                                window.ttq.track('InitiateOrdering', {                
                                    "contents": [
                                        {              
                                            "content_id": "0",           
                                            "content_name": "initiate a phone call" + (label ? " for " + label : ""),
                                        }
                                    ],
                                });
                            }
                        }
                        if (window.fbq){                                   
                            if (btnType === bookType){
                                window.fbq('trackCustom', 'InitiateBooking', {"content_name": "initiate a phone call" + (label ? " for " + label : "")});
                            }
                            else if (btnType === contactType || btnType === applyType){
                                window.fbq('trackCustom', 'InitiateContact', {"content_name": "initiate a phone call" + (label ? " for " + label : "")});
                            } 
                            else if (btnType === orderType){
                                window.fbq('trackCustom', 'InitiateOrdering', {"content_name": "initiate a phone call" + (label ? " for " + label : "")});
                            }                                
                        }
                    }
                    if (playMode !== "demo" && props.storyId != null && !usesDemoBookingMock(props.storyId, props.story)){
                        if (device.device.type === "smartphone" && ! (isIOS() && isSnapchatInAppBrowser())){
                            window.location.href = "tel:" + (value ? value : optionsToShow.phone);
                        }                          
                        else {                    
                            setSelectedValue(bookingType);
                            setSelectedPhone(value ? value : optionsToShow.phone);
                        }
                    }
                    else {
                        setDemoToastKey("DemoPhoneCallToast");
                    }
                }
                
            };    

            if (selectedValue == null){
                if (frameOpened){
                    const closeMock = () => {
                        setFrameOpened(false);
                        setFrameWithImageOverWebsite(true);
                        closeBookingMenu();
                        propagateFocusChange(false);
                    };

                    const isIframeFrame = !frameWithImageOverWebsite && frameOpened;
                    const isBookingMock = isIframeFrame && isDemoBookingMockUrl(frameOpened);

                    return (
                        <div style={{position: "absolute", width: storyDimensions.containerWidth, height: storyDimensions.containerHeight, display: "flex", justifyContent: "center", alignItems: "center", }}>
                            <div className="BlockingOverlay" style={{zIndex: 10, width: storyDimensions.containerWidth, height: storyDimensions.containerHeight, pointerEvents: "auto"}} onClick={closeMock}/> 
                            <WebPageMock key={isIframeFrame ? frameOpened : undefined} url={frameOpened} imageOverWebsite={frameWithImageOverWebsite} close={closeMock} open={frameOpened} width={storyDimensions.containerWidth - (frameWithImageOverWebsite? 0 : 32)} height={storyDimensions.containerHeight - (frameWithImageOverWebsite ? 0 : 128)} frameWidth={frameWidth} frameHeight={frameHeight} backgroundColor={isBookingMock ? (props.story?.secondaryColor || "#FFFFFF") : "#FFFFFF"} fadeIn={isIframeFrame ? 0.35 : undefined} iframeStyle={frameWithImageOverWebsite ? {} : {borderRadius: 8 * sizeMultiplier, borderWidth: 0} }/>
                            {deliveryToast}
                        </div>
                    );
                }     
                else {
                    return (
                        <>
                            <BookDialog selectedValue={() => setSelectedValue()} storyId={props.storyId} story={props.story} opened={true} onClose={close} optionsToShow={optionsToShow} titleType={btnType} />
                            {deliveryToast}
                        </>
                    );
                }
            }
            else if (selectedValue === phoneType){
                const deviceDetector = new DeviceDetector();
                const device = deviceDetector.parse(window.navigator.userAgent);                
                
                if (device.device.type === "smartphone"){
                    return deliveryToast;
                }
                else {
                    if (frameOpened){
                        return (
                            <>
                                <WebPageMock url={frameOpened} imageOverWebsite={frameWithImageOverWebsite} close={()=>{setFrameOpened(false);setFrameWithImageOverWebsite(true);closeBookingMenu();}} open={frameOpened} width={storyDimensions.containerWidth} height={storyDimensions.containerHeight}/>
                                {deliveryToast}
                            </>
                        );
                    }     
                    else {
                        return (
                            <>
                                <DialogContainer onClose={() => {setSelectedValue(null);setSelectedPhone(null);closeBookingMenu();}} opened={true} >
                                    <DialogTitle>{selectedPhone}{(device.device.type === "tablet" || device.device.type === "desktop") && <IconButton aria-label="call" style={{marginLeft: 8, color: "#49454F"}} onClick={()=>{window.open("tel:" + selectedPhone);}}><PhoneIcon /></IconButton>}</DialogTitle>
                                </DialogContainer>
                                {deliveryToast}
                            </>
                        );
                    }
                }
            }                   
            else{
                return deliveryToast;
            }
        }       
        else {
            return deliveryToast;
        }
    }
    else return deliveryToast;
}

export default BookScreen;